import { ErrorHandler, Injectable } from "@angular/core";
import { IonicErrorHandler, Platform } from "ionic-angular";
import "rxjs/add/operator/do";

// NOVA-1884: cooldown between chunk-failure reloads — prevents a reload loop
// if the fresh build itself fails to load.
const CHUNK_RELOAD_COOLDOWN_MS = 60000;
const CHUNK_RELOAD_AT_KEY = "curantis-chunk-reload-at";

@Injectable()
export class CurantisErrorService extends ErrorHandler {
  private ionicErrorHandler: IonicErrorHandler;

  constructor(public platform: Platform) {
    super();
    this.ionicErrorHandler = new IonicErrorHandler();
  }

  // general error logic here ie: throw new Error()
  public handleError(error) {
    super.handleError(error);
    if (this.platform.is("core") || this.platform.is("mobileweb")) {
      const chunkFailedMessage = /Loading chunk [\d]+ failed/;
      if (error && chunkFailedMessage.test(error.message)) {
        this.reloadForStaleChunk();
      }
    } else {
      this.ionicErrorHandler.handleError(error);
    }
  }

  // NOVA-1884: a chunk failure means this tab's build predates the current
  // release. Reload with a cache-busting query so a browser-cached index.html
  // can't re-reference the dead chunks; rate-limited so a broken build can't
  // put the tab into a reload loop.
  public reloadForStaleChunk() {
    const now = Date.now();
    let last = 0;
    try {
      last = Number(window.sessionStorage.getItem(CHUNK_RELOAD_AT_KEY)) || 0;
    } catch (e) {
      // sessionStorage unavailable — still reload below, just without the guard
    }
    if (now - last < CHUNK_RELOAD_COOLDOWN_MS) {
      console.error(
        "CurantisErrorService: chunk load failed again within the reload cooldown — suppressing reload to avoid a loop (NOVA-1884)"
      );
      return;
    }
    try {
      window.sessionStorage.setItem(CHUNK_RELOAD_AT_KEY, String(now));
    } catch (e) {
      // ignore
    }
    this.navigate(window.location.pathname + "?cb=" + now + window.location.hash);
  }

  // seam for tests — window.location itself cannot be spied on in the browser
  public navigate(url: string) {
    // danger: bypasses ionic navigation
    window.location.replace(url);
  }
}



// WEBPACK FOOTER //
// ./src/app/curantisErrorService.ts